import $ from 'jquery';
import { counterUp } from 'counterup2';
import 'waypoints/lib/noframework.waypoints';

export default class StatsBlock {
    constructor() {
        if($('.js-stats-block').length) {
            $('.js-stats-block__stat').each(function() {
                const $this = $(this);

                new Waypoint({
                    element: $this[0],
                    handler: function() {
                        counterUp( $this[0], {
                            delay: 16,
                            duration: 1000
                        });

                        this.destroy();
                    },
                    offset: 'bottom-in-view'
                });
            });
        };
    };
};
